import { t } from "@lingui/macro";
import { QuotesListing } from "@src/components/modules/budgets/quotes";
import { FullScreenContainer } from "@src/components/ui-kit";
import { NavigationProposals } from "@src/components/widgets/AppSubNav";
import { MainLayout } from "@src/components/widgets/Layout";
import { createFileRoute } from "@tanstack/react-router";

const Page = () => {
  return (
    <MainLayout
      noBottomMargin
      fullWidth
      title={t`Quotes`}
      navigation={<NavigationProposals />}
    >
      <FullScreenContainer noBottomMargin>
        <QuotesListing />
      </FullScreenContainer>
    </MainLayout>
  );
};

export const Route = createFileRoute("/budgets/quotes")({
  component: Page,
});
